import { render, staticRenderFns } from "./VehicleBookingDetails.vue?vue&type=template&id=2d8da115"
import script from "./VehicleBookingDetails.vue?vue&type=script&lang=js"
export * from "./VehicleBookingDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports